import { render } from "./PaymentSlipHistoryCashDetail.vue?vue&type=template&id=4d1efd2b&scoped=true"
import script from "./PaymentSlipHistoryCashDetail.vue?vue&type=script&lang=ts"
export * from "./PaymentSlipHistoryCashDetail.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4d1efd2b"

export default script